import { CookieContext } from './index'
import cookies from 'js-cookie'

export default function(_window: Window): CookieContext {
  return {
    get: (cookieName: string) => {
      return cookies.get(cookieName)
    },

    set: (cookieName, cookieValue, cookieOptions) => {
      cookies.set(cookieName, cookieValue, {
        expires: cookieOptions && cookieOptions.expires,
        domain: cookieOptions && cookieOptions.domain,
        path: cookieOptions && cookieOptions.path,
        secure: cookieOptions && cookieOptions.secure
      })

      return true
    }
  }
}
